export const NO_ROOM_RESOURCE_ID = "__no_room__";

export type CalendarScheduleUpdate = {
  plannedStart: string;
  plannedEnd: string;
  roomId?: number | null;
};

export function buildCalendarScheduleUpdate(input: {
  start: Date | null;
  end: Date | null;
  resourceId?: string | null;
}): CalendarScheduleUpdate | null {
  if (!input.start || !input.end) return null;

  const update: CalendarScheduleUpdate = {
    plannedStart: input.start.toISOString(),
    plannedEnd: input.end.toISOString(),
  };

  if (input.resourceId !== undefined) {
    update.roomId = input.resourceId === NO_ROOM_RESOURCE_ID ? null : Number(input.resourceId);
  }

  return update;
}
